import styled, { StyledComponentClass } from "styled-components";
import { IBaseButton } from "..";

export const Wrapper: StyledComponentClass<IBaseButton, any> = styled.a`
  overflow: hidden;
  outline: none;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  user-select: none;

  &[disabled] {
    touch-action: none;
  }
`;
